module.exports = __webpack_public_path__ + "img/37.40dbe084.svg";